import moment from "moment";
import { SHIFTS } from "@/constants/shifts";
import hasPlural from "./hasPlural";

/**
 * Radnici jedne firme: poručeno / preuzeto / razlika, status (nije preuzeo, deo, sve) i tabovi.
 * Zahteva nasleđen ReportMealsTabEmployees: filteredUsers, filters, customSearch, selectedCompany.
 */
export default {
  mixins: [hasPlural],
  data: () => ({
    tab: "all",
  }),
  computed: {
    isSingleDay() {
      return this.filters.dates.from === this.filters.dates.to;
    },
    /** Radnici koji imaju narudžbu u periodu; oni bez narudžbe se ne prikazuju. */
    workers() {
      return this.filteredUsers
        .filter((user) => (user.order_count || 0) > 0)
        .map((user) => this.toWorker(user));
    },
    stats() {
      const ordered = this.workers.reduce((sum, worker) => sum + worker.ordered, 0);
      const taken = this.workers.reduce((sum, worker) => sum + worker.taken, 0);
      return { ordered, taken, difference: ordered - taken };
    },
    tabs() {
      return [
        { key: "all", label: this.$t("report_mobile.status_all", { n: this.workers.length }) },
        { key: "open", label: this.$t("report_mobile.status_not_taken") },
        { key: "done", label: this.$t("report_mobile.status_taken") },
      ];
    },
    tabWorkers() {
      if (this.tab === "open") {
        return this.workers.filter((worker) => worker.status !== "all");
      }
      if (this.tab === "done") {
        return this.workers.filter((worker) => worker.status === "all");
      }
      return this.workers;
    },
    matchedWorkers() {
      const search = this.filters.search;
      if (!search) {
        return this.tabWorkers;
      }
      return this.customSearch(this.tabWorkers, [{ value: "name" }, { value: "idText" }], search);
    },
  },
  watch: {
    selectedCompany() {
      this.tab = "all";
    },
  },
  methods: {
    toWorker(user) {
      const ordered = user.order_count || 0;
      const taken = user.order_payed || 0;
      const status = taken <= 0 ? "none" : taken >= ordered ? "all" : "part";
      const name = [user.name, user.lastname].filter(Boolean).map(this.toLatin).join(" ");
      return {
        id: user.id,
        idText: String(user.id),
        name,
        initials: [user.name, user.lastname]
          .filter(Boolean)
          .map((part) => this.toLatin(part).charAt(0))
          .join(""),
        ordered,
        taken,
        // smene u kojima je radnik poručio (za oznake smena uz ime)
        shifts: SHIFTS.filter((shift) => Number(user[shift.key]) > 0).map((shift) => shift.id),
        status,
        statusLabel: this.statusLabel(status, taken, ordered),
        meta: this.workerMeta(user, ordered),
        source: user,
      };
    },
    statusLabel(status, taken, ordered) {
      if (status === "all") {
        return this.$t("report_mobile.status_taken");
      }
      if (status === "part") {
        return this.$t("report_mobile.taken_partly", { taken, total: ordered });
      }
      return this.$t("report_mobile.status_not_taken");
    },
    /** "ID 30624 · poručeno 15.10. 12:25" za jedan dan, "ID 30624 · 3 obroka" za period. */
    workerMeta(user, ordered) {
      const orderedAt = this.isSingleDay && user.date && moment(user.date).isValid();
      if (orderedAt) {
        return this.$t("report_mobile.worker_meta_time", {
          id: user.id,
          time: moment(user.date).format("DD.MM. HH:mm"),
        });
      }
      return this.$t("report_mobile.worker_meta_count", {
        id: user.id,
        count: this.pluralT("report_mobile.meals_n", ordered),
      });
    },
    /** Radnik za mesečni pregled (store: report/selectedEmployee). */
    toEmployeeContext(worker) {
      const { source } = worker;
      return {
        id: source.id,
        name: this.toLatin(source.name),
        lastname: this.toLatin(source.lastname),
        fullName: worker.name,
        companyId: this.selectedCompany?.id,
        companyName: this.toLatin(this.selectedCompany?.name || ""),
      };
    },
  },
};
